<template>
  <v-card color="#F9F9F9">
    <v-spacer></v-spacer>
    <v-container>
      <template>
        <div class="text-xs-center">
          <v-progress-circular
            :rotate="360"
            :size="100"
            :width="15"
            :value="value"
            color="teal"
          >
            {{ value }}
          </v-progress-circular>
        </div>
        <v-card-text class="text-xs-center indigo--text"
          >Descargando...</v-card-text
        >
      </template>
    </v-container>
    <v-spacer></v-spacer>
    <v-card-actions>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: {},

  data() {
    return {
      interval: {},
      value: 0,
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 4000);
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    this.interval = setInterval(() => {
      if (this.value === 100) {
        return (this.value = 0);
      }
      this.value += 10;
    }, 1000);
  },
};
</script>
